import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class GoogleAnalyticsWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.google_analytics.ID;
        this.name = DatabaseEnum.google_analytics.NAME;
        this.code = DatabaseEnum.google_analytics.CODE;
        this.equivalentTag = DatabaseEnum.google_analytics.EQUIVALENT_TAG;

        this.showLoadPropertiesTab = false;
        this.isCDC = true;
        this.showDatabaseTab = false;
        //data object tabs
        this.showDDLOption = true;
        this.isShowObjProperties = true;
        this.dataObjectConnDatabaseNm = 'Database';
        this.isFileType = true;
        this.showPropertiesTab = true;
        this.isNeedRedirectForTestDP = true;
        this.hideDatabaseNmDbColumn = true;
        this.hideSchemaNmColumn = false;
        this.disableTestDataPointButton = false;
        this.showDataDescription = false;

    }
    
    validateRepConn(repConnWrapper: RepConnWrapper): void {

    if (repConnWrapper.repConn.conn.access_Token_Flg === 'Y') {

        // Mandatory when Access Token Flag = Y
        if (!repConnWrapper.repConn.conn.consumerKey) {
            repConnWrapper.inValid_Cds.push('CONS_KEY');
        }

        if (!repConnWrapper.repConn.conn.consumerSecret) {
            repConnWrapper.inValid_Cds.push('CONS_SEC');
        }

        if (!repConnWrapper.repConn.conn.url) {
            repConnWrapper.inValid_Cds.push('CBK_URL');
        }

        // if (!repConnWrapper.repConn.conn.accessTokenSecret) {
        //     repConnWrapper.inValid_Cds.push('REFRESH_TOKEN');
        // }
        if (!repConnWrapper.repConn.conn.connType) {
        repConnWrapper.inValid_Cds.push('CONN_TYPE');
        }

    } else if (repConnWrapper.repConn.conn.access_Token_Flg === 'N') {

        // Mandatory when Access Token Flag = N
        if (!repConnWrapper.repConn.conn.accessToken) {
            repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
        }

        if (!repConnWrapper.repConn.conn.accessTokenSecret) {
            repConnWrapper.inValid_Cds.push('REFRESH_TOKEN');
        }
        if (!repConnWrapper.repConn.conn.connType) {
            repConnWrapper.inValid_Cds.push('CONN_TYPE');
        }
    }

    if (repConnWrapper.repConn.conn.flagent_Id === -1) {
        repConnWrapper.inValid_Cds.push('ESM00202');
    }
}

    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null, hideRowSelection: boolean = true): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper, hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper, component),
            this.attributeTabulator.getAttrType(objectWrapper),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            this.attributeTabulator.getAttrCategory(objectWrapper),
            //     this.attributeTabulator.getAttrPrec(),
            //     this.attributeTabulator.getAttrScale(),
            //      this.attributeTabulator.getNotNullFlag(),
            //       this.attributeTabulator.getAttrKeyTyp_Id(),
            //       this.attributeTabulator.getOrderBy(),
            //     this.attributeTabulator.getDescription(),
        ]
    }

    getSourceAttributeColumns(objectWrapper: ObjectWrapper, isComplex: boolean = false,
        isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false, component: any): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getClevel(objectWrapper, isComplex),
            this.attributeTabulator.getAttrNm(objectWrapper, component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
            this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
            this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
            this.attributeTabulator.getValid_Cd(objectWrapper, component),
        ]
    }
}
